export enum PerfilEnum {
    ADMINISTRATIVO = "ADMINISTRATIVO",
    GERENCIAL = "GERENCIAL",
    REGIONAL = "REGIONAL"
}